import { Autocomplete, TextField } from "@mui/material";
import { Controller, UseFormReturn } from "react-hook-form";
import { LiveResource } from "../../../types/TaskTypes";
import { getLifeFullName } from "../../../../Chat/components/ConversationList/conversationListHelpers";
import { useGetLivesQuery } from "../../../api/useGetLivesQuery";
import { useDebounce } from "use-debounce";
import { TCreateTaskForm } from "../helpers/createTaskSchema";
import Search from "@mui/icons-material/Search";

type TLivesAutocompleteFieldProps = {
  form: UseFormReturn<TCreateTaskForm, unknown, undefined>;
};

export const LivesAutocompleteField = (props: TLivesAutocompleteFieldProps) => {
  const [autocompleteLifeName] = useDebounce(
    props.form.watch("autocompleteLifeName"),
    500
  );

  const getLivesQuery = useGetLivesQuery({
    searchQuery: autocompleteLifeName,
  });

  const { form } = props;
  const { errors } = form.formState;

  const livesData = getLivesQuery?.data?.data?.data;

  const isLoading = getLivesQuery.isLoading;

  return (
    <Controller
      name="lifeInformation"
      control={form.control}
      render={({ field }) => (
        <Autocomplete
          {...field}
          /**
           * freeSolo: workaround to show "noOptionsText" when no data is found.
           * This option only works freeSolo is not active
           */

          onChange={(_, data) => {
            field.onChange(data ? data : null);
          }}
          openOnFocus
          options={livesData || []}
          filterOptions={(x) => x}
          noOptionsText="Nenhum dado encontrado"
          loading={isLoading}
          loadingText="Carregando..."
          getOptionLabel={(option) =>
            getLifeFullName((option as LiveResource)?.attributes)
          }
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          renderInput={(params) => (
            <TextField
              {...form.register("autocompleteLifeName")}
              {...params}
              label="Busque pacientes por Nome ou CPF"
              error={!!errors?.lifeInformation}
              helperText={errors?.lifeInformation?.message as string}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {params.InputProps.endAdornment}
                    <Search key="search-icon" />
                  </>
                ),
              }}
            />
          )}
        />
      )}
    />
  );
};
